import ShoppingBagIcon from "@ecologi/assets/icons/impact-shop/shopping-bag.svg";
import { NavSection } from "@ecologi/react-components/src/NavigationDrawer/navigation";
import { User } from "@ecologi/shared";
import { addIdsToNavSection } from "./add-ids-to-nav-section";

export const getNavSectionsForMarketingSite = ({
  productsInBasket,
  user,
}: {
  productsInBasket?: number;
  user?: User;
}): NavSection[] =>
  [
    [
      {
        label: "Home",
        path: "/",
      },
      {
        label: "Climate solutions",
        links: [
          {
            label: "All solutions",
            path: "/solutions",
          },
          {
            label: "Impact funds",
            path: "/solutions/impact-funds",
          },
          {
            label: "Fund flexibly",
            path: "/solutions/impact-shop",
            icon: {
              svg: <ShoppingBagIcon />,
              label: productsInBasket > 0 && productsInBasket,
            },
          },
          {
            label: "Integrate to your website",
            path: "/solutions/integrations",
          },
          {
            label: "Set up a subscription",
            path: "/solutions/climate-subscription",
          },
          {
            label: "Manage your emissions",
            path: process.env.NEXT_PUBLIC_ZERO_BASE_URL + "/signup",
          },
        ],
      },
      {
        label: "Why Ecologi",
        links: [
          {
            label: "About",
            path: "/why-ecologi/about",
          },
          {
            label: "Transparency",
            path: "/why-ecologi/trust-through-transparency",
          },
        ],
      },
      {
        label: "Impact",
        links: [
          {
            label: "Climate projects",
            path: "/projects",
          },
        ],
      },
      {
        label: "Resources",
        links: [
          {
            label: "Blog",
            path: "/articles",
          },
          {
            label: "Help centre",
            path: "https://help.ecologi.com/",
          },
          {
            label: "Webinars",
            path: "/resources/webinars",
          },
        ],
      },
    ],
    user
      ? [
          {
            label: "Your profile 🌿",
            path: user.getProfilePath(),
            route: user.isChildProfile
              ? "/[usernameOrId]/[childUsernameOrId]"
              : "/[usernameOrId]",
          },
          {
            label: " Logout",
            path: "/api/logout",
          },
        ]
      : [
          {
            label: "Sign in 🌿",
            path: "/api/login",
          },
          {
            label: "Get started",
            path: "/solutions",
          },
        ],
    [
      {
        label: "Speak to the team",
        path: "/page/schedule-a-call",
      },
    ],
  ].map(addIdsToNavSection);
